import React from 'react';
import './jds.css';
import { CloseIcon, SearchIcon } from './icons';

// Campo de busca JDS: ícone de lupa, vira "limpar" quando há texto e onClear.
export function JdsSearchInput({
  id,
  placeholder,
  filterText,
  onFilter,
  onClear,
}) {
  return (
    <div style={{ position: 'relative', width: 220 }}>
      <input
        id={id}
        type="text"
        placeholder={placeholder}
        className="form-control"
        style={{ paddingRight: 'var(--space-40)' }}
        value={filterText}
        onChange={onFilter}
      />
      {filterText && onClear ? (
        <button
          type="button"
          className="jds-btn jds-btn--ghost jds-btn--neutral jds-btn--icon jds-btn--sm"
          style={{ position: 'absolute', top: 4, right: 4 }}
          onClick={onClear}
          aria-label="Limpar busca"
        >
          <CloseIcon />
        </button>
      ) : (
        <span
          style={{
            position: 'absolute',
            top: 0,
            right: 'var(--space-12)',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            color: 'var(--fg-neutral-subtle)',
            pointerEvents: 'none',
          }}
        >
          <SearchIcon />
        </span>
      )}
    </div>
  );
}
